import React from "react"
import Flex from "@irati/ui/src/Flex"
import idHelper from "@irati/utils/id"
import {shouldDisplayDealAvatar} from "@irati-web/perks/src/utils/deals/imageUtils"
import {determineDealThumbnailImage} from "@irati/deals/helpers/deals/appearance"
import withBranding from "@irati/brand/withBranding"
import Spacing from "@irati/ui/src/Spacing"
import {H1, H5} from "@irati/ui/src/Typography"
import {getTimeLimitedType} from "@irati/deals/helpers/deals/isTimeLimited"
import {isDealUnavailable} from "@irati/deals/helpers/deals/isDealUnavailable"
import {MobileDealAvatar} from "./styled/DealAvatar"
import DealHighlight, {DealHighlightRow} from "../../DealHighlight"
import UnavailableDeal from "./UnavailableDeal"
import {HeaderProps} from "."
import Savings from "../../DealImportantInfo/Savings"

const DealHeader: React.FC<HeaderProps> = ({deal, branding, ...props}) => {
  const thumbnailImageSrc = shouldDisplayDealAvatar(deal) ? determineDealThumbnailImage(deal, branding) : null
  const id = idHelper("deal-header-details", props)

  const {deliveryHighlight} = deal
  const typeHighlight = getTimeLimitedType(deal)

  return (
    <>
      <Flex direction="column">
        {thumbnailImageSrc && (
          <MobileDealAvatar data-test="top-thumbnail" src={thumbnailImageSrc} className="dealInfoBlock_dealThumbnail" withShadow />
        )}
        <Spacing paddingLeft="25px" marginTop="10px">
          <Flex direction="column">
            {deal.brandName && <H5 color="contrast">{deal.brandName}</H5>}
            <H1 marginBottom={2}>{deal.header}</H1>
            <Flex justifyContent="space-between">
              <DealHighlight>
                <DealHighlightRow id={idHelper("type", id)} type={typeHighlight} size={20} />
                <DealHighlightRow id={idHelper("delivery", id)} type={deliveryHighlight} size={20} />
              </DealHighlight>
              <Savings id={idHelper("savings", id)} deal={deal} />
            </Flex>
          </Flex>
        </Spacing>
      </Flex>
      {isDealUnavailable(deal) && (
        <Spacing marginTop={2}>
          <UnavailableDeal />
        </Spacing>
      )}
    </>
  )
}

export default withBranding(DealHeader)
